<template>
  <ValidationObserver ref="adrsForm" v-slot="{ handleSubmit }">
    <common ref="common"/>
    <v-card class="rounded-xl">
      <v-toolbar flat>
        <v-toolbar-title>
          <v-icon left>mdi-account</v-icon>Address
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="overflow-80 pt-2">
        <!-- <ValidationProvider
            name="Street Name"
            :rules="{ required: true, max: 10 }"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model="firstName"
              outlined
              name="Street Name"
              label="Street name"
              :error-messages="errors"
            >
            </v-text-field>
          </ValidationProvider> -->
        <!-- <ValidationProvider
            name="Area"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="Last Name"
              label="Last name"
              :error-messages="errors"
            >
            </v-text-field>
          </ValidationProvider> -->
        <!-- <ValidationProvider name="City" v-slot="{ errors }" rules="required">
            <v-text-field
              outlined
              name="City"
              label="City"
              :error-messages="errors"
            >
            </v-text-field>
          </ValidationProvider> -->
        <!-- <ValidationProvider
            name="State"
            v-slot="{ errors }"
            rules="required"
          >
            <v-text-field
              outlined
              name="State"
              label="State"
              :error-messages="errors"
            >
            </v-text-field>
            
          </ValidationProvider> -->
        <cmpaddress
          ref="cmpAdrs"
          :addComp="dtls.person.postalAddress"
          :isIndian="true"
        />
      </v-card-text>
      <v-card-actions class="d-flex justify-end px-6">
        <v-btn dark color="primary" @click="handleSubmit(save)">Save</v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>
<script>
import { callApi } from "@/api/others";
import { ValidationObserver, ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    cmpaddress: () => import("@/components/tools/cmpaddress.vue"),
    common: () => import("@/components/tools/common.vue")
  },
  props: {
    mbr: Object,
  },
  data: () => ({
    dtls: {
      person: {
        postalAddress: {
          district: {},
          pinCode: "",
        },
      },
    },
    cmp: {},
    MobileNo: "",
    firstName: "",
  }),
  mounted() {
    this.clonembr();
  },
  methods: {
    clonembr() {
      this.dtls = JSON.parse(JSON.stringify(this.mbr));
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    save() {
      let val = this.$refs.cmpAdrs.addComp;
      console.log("val", val);
      let url = "/api/wesupport/Member/AddressSave";
      callApi(url, "post", this.dtls)
        .then((res) => {
          this.manageResponse(res);         
        })
        .catch((err) => {
          this.manageResponse(err.response);
        });
    },
    manageResponse(res){
      this.$emit("showResponse",res);
      this.closeDialog();
    }
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>
